import BaseFormModel from './models/baseFormModel';
import ApiController from '../api/apiController';
import AppAuthController from '../app/appAuthController';
import { formErrorMessages } from './constants/formErrorMessages';

const SELECTOR = '#set-new-password-form';

const VALIDATION_SCHEME = {
    password: [
        {
            rule: 'required',
            errorMessage: formErrorMessages.required
        },
        {
            validator: (value) => value.trim().length >= 8,
            errorMessage: formErrorMessages.password
        }
    ],
    password_confirmation: [
        {
            rule: 'required',
            errorMessage: formErrorMessages.required
        },
        {
            validator: (value, fields) => {
                const passwordField = Array.from(Object.values(fields)).find((field) => field.elem.getAttribute('name') === 'password');

                return value === passwordField?.elem.value;
            },
            errorMessage: formErrorMessages.passwordRepeat
        }
    ]
};

export default class SetNewPasswordForm extends BaseFormModel {
    apiController;
    authController;

    constructor() {
        super();

        this.apiController = new ApiController();
        this.authController = new AppAuthController();

        this.init(SELECTOR, {
            validationScheme: VALIDATION_SCHEME,
            onSubmit: this.onSubmit
        });
    }

    async onSubmit() {
        const data = Object.fromEntries(new FormData(this.form));

        const result = await this.authController.setNewPassword(data);

        if (!result.error) {
            this.showFormSuccess();
        }

        return result;
    }
}
